import React, { CSSProperties, ReactNode } from 'react';
import { Marker as MapMarker } from 'react-map-gl/mapbox';
import { MarkerOptions } from 'mapbox-gl';

export interface MarkerProps {
  coordinates?: [number, number] | number[] | null;
  anchor?: MarkerOptions['anchor'];
  offset?: MarkerOptions['offset'];
  style?: CSSProperties;
  className?: string;
  children?: ReactNode;
}

// react-mapbox-gl positioned its markers as plain overlays at z-index 3.
const DEFAULT_STYLE: CSSProperties = { zIndex: 3 };

export const Marker = ({
  coordinates,
  anchor,
  offset,
  style,
  className,
  children
}: MarkerProps) => {
  if (!coordinates) return null;
  return (
    <MapMarker
      longitude={coordinates[0]}
      latitude={coordinates[1]}
      anchor={anchor}
      offset={offset}
      style={{ ...DEFAULT_STYLE, ...style }}
      className={className}
    >
      {children}
    </MapMarker>
  );
};
